module.exports = __webpack_public_path__ + "static/img/4.cec666dc.png";